import { gql } from '@apollo/client';

export const GET_PERIOD_GROUPS = gql`
  query GetPeriodGroups($input: PeriodGroupsInput!) {
    periodGroups: getPeriodGroups(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          startDate
          startDate
          periodsCount
          frequency {
            id
            name
          }
        }
      }
    }
  }
`;
